import React, { useContext, useState, useEffect } from "react";
import { Typography, Box, Chip, Grid, Divider } from "@mui/material";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import {isTestEnv} from "../../globals";

export const CustomerDetails = ({ fnccust }) => {
  const [expandedPanel, setExpandedPanel] = useState(false);
  const handleChange = (event, isExpanded) => {
    setExpandedPanel(isExpanded);
  };
  
  isTestEnv && console.log("fnccustCustomerDetails", fnccust);
  const NCUSTBRANCH_SUBFORM_PAYDES = fnccust?.NEO_CUSTBRANCH_SUBFORM.filter(
    (item, index) => item.PAYDES != null
  );
  const NEO_FNCCUSTCOMP_SUBFORM_PAYDES = fnccust?.NEO_FNCCUSTCOMP_SUBFORM.filter(
    (item, index) => item.PAYDES != null
  );
  const NFNCCUSTCOMP_SUBFORM_PAYMENTNAME =
    fnccust?.NEO_FNCCUSTCOMP_SUBFORM.filter(
      (item, index) => item.PAYMENTNAME != null
    );

  const typography = {
    "מספר לקוח:": fnccust?.CUSTNAME,
    "שם לקוח:": fnccust?.CUSTDES,
    "מספר חברה:": fnccust?.NEO_WTAXNUM,
    "מספר לקוח מרכז:": fnccust?.NEO_CUSTNAME,
    "שם לקוח מרכז:": fnccust?.NEO_CUSTDES,
  };
  return (
    <Accordion expanded={expandedPanel} onChange={handleChange} disabled={fnccust===null}>
      <AccordionSummary
        expandIcon={<ArrowDropDownIcon />}
        aria-controls="panel-content"
        id="panel-header"
        style={{
          backgroundColor: expandedPanel ? "#f0f0f0" : "inherit",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            padding: "5px",
            borderRadius: "5px",
          }}
        >
          <span
            style={{
              fontWeight: "bold",
              fontSize: "1.2rem",
            }}
          >
            פרטי לקוח
          </span>
          <div style={{ display: "flex", alignItems: "center" }}>
            <span style={{ marginRight: "40px" }}>{fnccust?.CUSTDES}</span>
            <span style={{ marginRight: "60px" }}>{fnccust?.NEO_WTAXNUM}</span>
          </div>
        </div>
      </AccordionSummary>
      <AccordionDetails>
        <Box>
          {Object.keys(typography).map((item, index) => (
            <Typography key={index} variant="body2" sx={{ mb: 1 }}>
              <Box component="span" fontWeight="bold" fontSize="1.1rem">
                {item}
              </Box>{" "}
              {typography[item]}
            </Typography>
          ))}

          {(NCUSTBRANCH_SUBFORM_PAYDES?.length > 0 ||
            NEO_FNCCUSTCOMP_SUBFORM_PAYDES?.length > 0 ||
            fnccust?.PAYDES) && (
            <Typography
              variant="body2"
              sx={{
                mb: 1,
                display: "flex",
                flexWrap: "wrap",
                alignItems: "center",
              }}
            >
              <Box component="span" fontWeight="bold" fontSize="1.1rem" mr={1}>
                תנאי תשלום:
              </Box>
              {NCUSTBRANCH_SUBFORM_PAYDES.length > 0 ? (
                NCUSTBRANCH_SUBFORM_PAYDES.map((branch, index) => (
                  <Box component="span" key={index} sx={{ mr: 1 }}>
                    {`${branch.BRANCHDES}${
                      branch.PAYDES
                        ? ` - ${branch.PAYDES} ${NCUSTBRANCH_SUBFORM_PAYDES?.length > index + 1
                              ? `|`
                              : ""
                          }`
                        : ""
                    }`}
                  </Box>
                ))
              ) : NEO_FNCCUSTCOMP_SUBFORM_PAYDES.length > 0 ? (
                NEO_FNCCUSTCOMP_SUBFORM_PAYDES.map((company, index) => (
                  <Box component="span" key={index} sx={{ mr: 1 }}>
                    {`${company.COMPANYDES}${
                      company.PAYDES
                        ? ` - ${company.PAYDES} ${NEO_FNCCUSTCOMP_SUBFORM_PAYDES?.length > index + 1
                              ? `|`
                              : ""
                          }`
                        : ""
                    }`}
                  </Box>
                ))
              ) : (
                <Box component="span">{fnccust?.PAYDES}</Box>
              )}
            </Typography>
          )}

          {NFNCCUSTCOMP_SUBFORM_PAYMENTNAME?.length > 0 && (
            <Typography
              variant="body2"
              sx={{
                mb: 1,
                display: "flex",
                flexWrap: "wrap",
                alignItems: "center",
              }}
            >
              <Box component="span" fontWeight="bold" fontSize="1.1rem" mr={1}>
                אמצעי תשלום:
              </Box>
              {NFNCCUSTCOMP_SUBFORM_PAYMENTNAME.map((company, index) => (
                <Box component="span" key={index} sx={{ mr: 1 }}>
                  {`${company.COMPANYDES}${
                    company.PAYMENTNAME
                      ? ` - ${company.PAYMENTNAME} ${NFNCCUSTCOMP_SUBFORM_PAYMENTNAME?.length > index + 1
                            ? `|`
                            : ""
                        }`
                      : ""
                  }`}
                </Box>
              ))}
            </Typography>
          )}
        </Box>
      </AccordionDetails>
    </Accordion>
  );
};